import React from 'react';
import {Card, Goals, Flex} from 'components';
import {moment} from 'helpers';

export function StartPoint({ starting_date }) {
  return !!starting_date && (
    <Card>
      <Goals.Milestones.Checkbox />
      <Card.Body>
        <Flex justified>
          <Card.Text>Start goal</Card.Text>
          <small>{ moment.unix(starting_date).format() }</small>
        </Flex>
      </Card.Body>
    </Card>
  );
}
